import { apiSlice } from "app/api/apiSlice";


export const notificationApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Notification'],
    endpoints: builder => ({

        // GET All My Notifications
        getAllNotifications: builder.query({
            query: ({ showArchived, pageNumber }) => {
                return {
                    url: 'notifications',
                    params: {
                        includeArchived: showArchived,
                        page: pageNumber
                    }
                }
            },
            providesTags: ['Notification']
        }),

        // GET My Unread Notifications
        getUnreadNotifications: builder.query({
            query: () => 'notifications/unread',
            providesTags: ['Notification']
        }),

        // PUT Notification in Archive
        archiveNotification: builder.mutation({
            query: notificationGuid => ({
                url: 'notifications/archive',
                method: 'PUT',
                params: { guid: notificationGuid }
            }),
            invalidatesTags: ['Notification']
        }),

        // PUT Notification Read
        markNotificationAsRead: builder.mutation({
            query: notificationGuid => ({
                url: 'notifications/read',
                method: 'PUT',
                params: { guid: notificationGuid }
            }),
            providesTags: ['Notification']
        }),

        // PUT All Notifications Read
        marksAllNotificationsAsRead: builder.mutation({
            query: () => ({
                url: 'notifications/readAll',
                method: 'PUT'
            }),
            invalidatesTags: ['Notification']
        }),

        // PUT All Notifications Archived
        archiveAllNotifications: builder.mutation({
            query: () => ({
                url: 'notifications/archiveAll',
                method: 'PUT'
            }),
            invalidatesTags: ['Notification']
        }),
    })
})

export const {
    useGetAllNotificationsQuery,
    useGetUnreadNotificationsQuery,
    useArchiveNotificationMutation,
    useMarkNotificationAsReadMutation,
    useMarksAllNotificationsAsReadMutation,
    useArchiveAllNotificationsMutation
} = notificationApiSlice


